import { CardContent, Grid, Box, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import TableHeadCell from 'components/TableHeadCell'
import { useTranslation } from 'react-i18next'

export default function AcademicYearProviderListSkeleton() {
  const { t } = useTranslation()
  return (
    <Box data-component="AcademicYearList" sx={{ minHeight: '50%' }}>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} md={12}>
            <CardContent sx={{ pl: 0, pr: 0, minHeight: '600px' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>{t('Name')}</TableHeadCell>
                    <TableHeadCell>{t('Type')}</TableHeadCell>
                    <TableHeadCell>{t('Start Date')}</TableHeadCell>
                    <TableHeadCell>{t('End Date')}</TableHeadCell>
                    <TableHeadCell>{t('Actions')}</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[0, 1, 2].map(item => (
                    <TableRow key={item}>
                      <TableCell sx={{ width: '4em' }}>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
        </Grid>
      </Grid>
    </Box>
  )
}
